module.exports = __webpack_public_path__ + "img/location_s.46aa1d11.svg";